export enum NotificationStatus {
  READ= 'Read',
  UNREAD = 'Unread'
}
